import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getBalance } from "../lib/balance";

export default function Navbar({ onSettings, inSettings }) {
  const { user, logout } = useAuth();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (user?.role === "customer" && user?.email) {
      getBalance(user.email).then(setBalance).catch(() => {});
    }
  }, [user]);

  if (!user) return null;

  return (
    <nav className="app-nav">
      <div className="nav-logo">
        <div className="nav-logo-icon">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
            <path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" stroke="#fff" strokeWidth="2"/>
            <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" stroke="#fff" strokeWidth="2"/>
            <line x1="12" y1="12" x2="12" y2="17" stroke="#fff" strokeWidth="2"/>
            <line x1="9" y1="14.5" x2="15" y2="14.5" stroke="#fff" strokeWidth="2"/>
          </svg>
        </div>
        <div>
          <div className="nav-brand">LebMarket</div>
          <div className="nav-sub">Shipping Portal</div>
        </div>
      </div>
      <div className="nav-right">
        <span className="nav-username">{user.name || user.email}</span>

        {/* Balance pill — always visible for customers */}
        {user.role === "customer" && balance !== null && (
          <span style={{
            fontSize: 13, fontWeight: 700, padding: "4px 12px",
            borderRadius: 20, background: balance >= 0 ? "var(--green-light)" : "#FCEBEB",
            color: balance >= 0 ? "var(--green-dark)" : "var(--red-dark)",
            border: `1px solid ${balance >= 0 ? "var(--green-mid)" : "#F7C1C1"}`,
          }}>
            💰 ${balance.toFixed(2)}
          </span>
        )}

        <span className={`badge badge-${user.role}`}>
          {user.role === "admin" ? "Admin" : "Customer"}
        </span>

        {user.role === "customer" && (
          inSettings
            ? <button className="logout-btn" onClick={onSettings}>← Back to packages</button>
            : <button className="logout-btn" onClick={onSettings}>⚙ Settings</button>
        )}
        <button className="logout-btn" onClick={logout}>Sign out</button>
      </div>
    </nav>
  );
}
